import React from 'react';

function SvgPersonnalisable() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
      <defs>
        <style>{".personnalisable_svg__cls-1{fill:#6b87b1}"}</style>
      </defs>
      <g id="personnalisable_svg__Calque_2" data-name="Calque 2">
        <g id="personnalisable_svg__Calque_33" data-name="Calque 33">
          <path
            className="personnalisable_svg__cls-1"
            d="M25 2A23 23 0 112 25 23 23 0 0125 2m0-2a25 25 0 1025 25A25 25 0 0025 0z"
          />
          <path
            className="personnalisable_svg__cls-1"
            d="M12.82 35.13L13 35l1.77-1.83 2 2-2 2L13 35.39l-.19-.17zM26.11 12.84v2.84h-1.43v-2.84zM23.68 17.11l2.25 1.68c.41.3.82.6 1.22.91a.36.36 0 00.41.07l3.86-1.31.22-.07c0 .1 0 .18-.07.26-.43 1.28-.86 2.56-1.3 3.84a.37.37 0 00.06.39l2.43 3.25.16.23h-.28l-4.08-.05a.32.32 0 00-.32.17l-2.35 3.32a1.87 1.87 0 01-.17.23c-.14-.47-.28-.91-.42-1.34-.29-.94-.58-1.87-.86-2.81a.38.38 0 00-.28-.28l-4-1.23-.16-.05.21-.16 3.28-2.32a.43.43 0 00.22-.42c0-1.33 0-2.67-.05-4z"
          />
          <path
            className="personnalisable_svg__cls-1"
            d="M17.9 34.17l-2-2L16 32l5.49-5.49a.32.32 0 01.39-.1c.37.13.75.25 1.13.35a.33.33 0 01.26.27c.11.39.25.78.36 1.17a.35.35 0 01-.05.27zM34.94 14.11l1 1-3 3-1-1zM22.39 18.51l-1 1-3-3 1-1zM31.52 27.66l3 3-1 1-3-3zM16.11 23.25v-1.4H19v1.4zM34.36 23.8h2.82v1.4h-2.82zM26.79 31.09h1.4v2.83h-1.4z"
          />
        </g>
      </g>
    </svg>
  );
}

export default SvgPersonnalisable;
